export const setIsAuthenticated = (state,data) => {
    state.isAuthenticated = data
}

export const setUser = (state,data) => {
    state.user = data
}

export const setLoading = (state,data) => {
    state.loading = data
}



// WEBPACK FOOTER //
// ./src/store/mutations.js